import React from "react";
import { render } from "react-dom";
import { getCsrfToken, createRef } from "./shared.js";

import basicData from "./basic_data.js";
import { getElementData } from "./data_helpers.js";
let appData = getElementData("#app_data", "data"),
  pdfIcon = getElementData("#app_data", "pdf_icon");

class RequestPopup extends React.PureComponent {
  state = {};

  render() {
    let { closePopup } = this.props;
    let { status = "" } = this.state;
    const setStatus = (type, data) => {
      if (type === "done") {
        delete this.state.status;
        closePopup();
        return;
      }

      let status = new String(type);
      Object.assign(status, data);
      this.setState({ status });
    };

    return (
      <div className="request-popup">
        {status.valueOf() === "success" ? (
          <SuccessMessage {...{ closePopup, request: status }} />
        ) : (
          <RequestForm {...this.props} {...{ status, setStatus }} />
        )}
      </div>
    );
  }
}

let RequestForm = ({ target, report, user, status, setStatus }) => (
  <form
    className="request-form"
    method="POST"
    action={report.request_url}
    onSubmit={(evt) => {
      evt.preventDefault();

      // NOTE: we rely on browser for form validation
      let form = evt.target,
        data = new FormData(form),
        req = new XMLHttpRequest();
      req.open(form.method, form.action, true);
      req.setRequestHeader("X-CSRFToken", getCsrfToken());
      req.send(data);

      setStatus("loading", { request: req });
      req.onload = function () {
        if (req.status === 200 || req.status === 201) {
          setStatus("success", {
            email: data.get("email"),
            status_url: report.status_url,
          });
        } else {
          setStatus("error", {
            message: `Unexpected server response. Please try again. (${req.status})`,
          });
        }
      };
      req.onerror = function () {
        setStatus("error", {
          message: `Network error. Please check your connection before trying again.`,
        });
      };
    }}
  >
    <p>
      You are requesting the <span className="report-name">{report.name}</span>{" "}
      for <span className="target-name">{target.name}</span>. Reports typically
      take an hour to prepare.
    </p>
    <label>
      Please {user.email ? "confirm" : "enter"} your email address:
      <br />
      <input
        name="email"
        type="email"
        required
        placeholder="you@example.com"
        defaultValue={user.email}
      />
    </label>
    {status.valueOf() === "error" ? (
      <p className="error">{status.message}</p>
    ) : null}
    <div className="actions">
      <button
        type="button"
        className="btn btn-default"
        onClick={(evt) => {
          if (status.valueOf() === "loading") {
            status.request.onerror = null;
            status.request.abort();
          }
          setStatus("done");
        }}
      >
        Cancel
      </button>
      <button
        className="btn btn-primary"
        disabled={status.valueOf() === "loading"}
      >
        {status.valueOf() === "error" ? "Retry" : "Request Report"}
      </button>
    </div>
  </form>
);

let SuccessMessage = ({ request, closePopup }) => (
  <div className="success-message">
    <p>Your request has been received!</p>
    <p>
      Once the report is ready, we will notify you by email at{" "}
      <span className="email">{request.email}</span> and you will be able to
      download the report at{" "}
      <a className="status" href={request.status_url}>
        {request.status_url}
      </a>
      .
    </p>
    <button
      type="button"
      className="btn btn-primary"
      onClick={(evt) => {
        closePopup();
      }}
    >
      Dismiss
    </button>
  </div>
);

class DownloadsPage extends React.PureComponent {
  state = {};

  contentRef = createRef();

  componentDidMount() {
    // HACK: incorporate Django-generated debug page links into our own layout…
    let tgtEl = this.contentRef.current,
      srcEl = document.getElementById("react_extra_content");
    // HT: https://stackoverflow.com/questions/20910147/#comment50396640_20910214
    while (srcEl && srcEl.childNodes.length)
      tgtEl.appendChild(srcEl.firstChild);
  }

  render() {
    let { user, target, reports } = this.props;
    let {
      survey: { labels: L },
    } = this.props;
    let { report } = this.state;

    return (
      <div className="grid">
        <div className="column col-narrow" />
        <div className="column col-wide">
          <h1>Downloads</h1>
          <p>
            You can download PDF reports on the {L.overall_product} and related
            measures.
          </p>
          <h2>Reports for {target.name}</h2>
          <ul className="reports-list">
            {reports.map((d) => (
              <li key={d.type}>
                <a
                  href={d.request_url}
                  onClick={(evt) => {
                    evt.preventDefault();

                    this.setState({ report: d });
                  }}
                >
                  <img className="pdf dl icon" src={pdfIcon} />
                  {d.name}
                </a>
                {d.generate_url ? (
                  <span>
                    {" "}
                    (Staff-only: <a href={d.generate_url}>direct download</a>
                    {" / "}
                    <a href={`${d.generate_url}?dbg_html&no_ssr`}>debug HTML</a>
                    {" / "}
                    <a href={`${d.generate_url}?dbg_html`}>raw SSR</a>)
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
          <div ref={this.contentRef} />
        </div>
        <div className="column col-narrow" />
        {report ? (
          <RequestPopup
            {...{ user, target, report }}
            closePopup={() => {
              this.setState({ report: null });
            }}
          />
        ) : null}
      </div>
    );
  }
}

render(
  <DownloadsPage {...basicData} {...appData} />,
  document.querySelector("#react_target"),
);
